/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AppRoutes } from "src/app/constants";
import { IntegrationsPage } from "./integrations.page";

const routes: Routes = [
  {
    path: "",
    component: IntegrationsPage,
  },
  {
    path: AppRoutes.googleReviews,
    loadChildren: () => import("./google-reviews/google-reviews.module").then(m => m.GoogleReviewsPageModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class IntegrationsPageRoutingModule {}
